import {customerDeviceIdentity} from '../../../shared/customer-review-display.js';
import React from 'react';
import {View} from 'react-native';
import {Text} from '../copy';
import {useLive} from '../live';
import {useTokens} from '../theme/tokens';
import {WearerAvatar} from './WearerPhoto';
import {TrackerStatusStrip,useTrackerStatus} from './ConnectionIndicators';
import {Card,Pill} from './primitives';

// One status card for personal alarms and every registered GPS model.
export function DeviceStatusCard({children}:{children?:React.ReactNode}){
 const {tracker,state}=useLive(),{colors,type,spacing}=useTokens(),connection=useTrackerStatus().mobile;
 const connectionLabel=connection.key==='connected'?'Online':connection.key==='offline'?'Offline':connection.key==='sleeping'?'Planlagt dvale':connection.key==='waiting'?'Afventer kontakt':'Forbindelse ukendt';
 return <Card><View style={{flexDirection:'row',flexWrap:'wrap',alignItems:'center',gap:spacing.sm}}>
  <WearerAvatar/><View style={{flexGrow:1,flexBasis:140,minWidth:0,gap:3}}>
   <Text style={{color:colors.text,fontSize:type.heading,fontWeight:'800'}}>{tracker.entity.personName}</Text>
   <Text style={{color:colors.textMuted,fontSize:type.label}}>{tracker.entity.trackerName} · {customerDeviceIdentity(state.snapshot?.device)??"—"}</Text>
  </View><Pill prominent tone={connection.tone==='positive'?'positive':connection.tone==='attention'?'attention':connection.tone==='critical'?'critical':'neutral'} icon="connection">{connectionLabel}</Pill>
 </View><TrackerStatusStrip/>{children}</Card>;
}
